import React from 'react';
import { number, string } from 'prop-types';
import { N400 } from '@/colors/colorsV1';

const SuccessFilled = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Style=Filled">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.6727 10.7399C17.0813 10.3684 17.1114 9.73599 16.7399 9.32733C16.3684 8.91868 15.736 8.88856 15.3273 9.26007L10.5329 13.6187L9.20711 12.2929C8.81658 11.9024 8.18342 11.9024 7.79289 12.2929C7.40237 12.6834 7.40237 13.3166 7.79289 13.7071L9.72547 15.6397C10.1407 16.0549 10.8088 16.0708 11.2432 15.6758L16.6727 10.7399Z"
        fill={color}
      />
    </g>
  </svg>
);

SuccessFilled.propTypes = {
  color: string,
  size: number,
};

SuccessFilled.defaultProps = {
  color: N400,
  size: 20,
};

export default SuccessFilled;
